import Component from "../../lib/component";

export const TogglerWrapConfig = {
    baseHtmlClass: 'toggler_btns_wrap',
    selector: '.toggler_btns_wrap',
};

export class TogglerWrap extends Component {

    constructor(id_or_element, togglerBtns) {
        super({
            element: id_or_element,
            config: TogglerWrapConfig
        });

        this.togglerBtns = togglerBtns;
        this.styles = this.togglerBtns.getStatesFromHtmlClasses();
        this.render();
    }

    render() {
        this.styles.forEach((style)=>{
           this.addHtmlClassState(style);
        });
    }

}